import ToppingItems from '../ToppingItems/topping-items';

export default ToppingItems;